export default {
	zhifujieguoyanzhengzhong: 'Hasil pembayaran saat ini sedang diperiksa, silakan bersabar dan tunggu.',
	zhengzaiweininchaxun: 'Kami sedang memeriksa untuk Anda. Terima kasih atas kesabaran Anda',
	qingshuruhuoxuanzenidechengshi: 'Silakan masukkan atau pilih tujuan Anda',
	qingshuruchufadidian: 'Silahkan masukan lokasi keberangkatan',
	qingshurumudidi: 'Silahkan masukan tujuan',
	qinglijiyuwomenlianxin: 'Hubungi kami hari ini untuk pertanyaan atau bantuan untuk pemesanan Anda.',
	lijiyuwomenliaotian: 'Mulai percakapan dengan kami sekarang',
	kehufuwurexian: 'Hotline layanan pelanggan',
	xuyaobangzhuma: 'Butuh Bantuan?',
	geiwomenfadianziyoujian: 'Email kami',
	chaxunbiaoge: 'Bentuk Kontak',
	songxinren: 'Pengirim Pesan',
	xingming: 'Nama Lengkap',
	gongsimingcheng: 'Nama Perusahaan',
	youjiandizhi: 'Alamat Email',
	lianxidianhua: 'Nomor Kontak',
	zhuti: 'Subjek',
	liuyan: 'Pesan',
	tijiao: 'Kirim',
	lianxiwomen: 'Hubungi Kami',
	shouyetishixinxi: 'Harga yang tercantum di atas hanya untuk penerbangan pulang pergi kelas ekonomi. Harga sebenarnya mungkin berbeda. Syarat dan ketentuan berlaku.',
	shangyiye: 'Sebelumnya',
	xiayiye: 'Selanjutnya',
	fangda: 'Meningkatkan',
	suoxiao: 'Mengurangi',
	shengdantishi: 'Gagal mengirim perintah, kembali ke halaman hasil pencarian dan mencari lagi',
	qushouye: 'Buka Beranda',
	hangbanyishouqing: 'Tiket Penerbangan Terjual Habis',
	zhifushibai: 'Pembayaran Gagal',
	zhifuchaoshi: 'Pembayaran Waktu',
	chongxinzhifu: 'Pembayaran Ulang',
	yudingshibai: 'Pemesanan Gagal',
	dingdanzhengzaichulizhong: 'Pesanan sedang diproses, silakan perbaharui dan periksa statusnya nanti.',
	yiwancheng: 'Berhasil',
	zhifufangshi: 'Cara Pembayaran'
};
